type RetryMessage = {
  id: string;
  role: string;
  metadata?: Record<string, unknown>;
};

/** Resolve retries only within the selected path, including chains of partial replies. */
export function interruptedChatRetryUserMessage<T extends RetryMessage>(messages: readonly T[]): T | null {
  const tail = messages[messages.length - 1];
  if (!tail) return null;
  if (tail.role === "user") return tail;
  if (tail.role !== "assistant"
    || !(tail.metadata?.agentInterrupted === true || tail.metadata?.partialRecovery === true)) return null;
  const trigger = tail.metadata?.triggerUserMessageId;
  if (typeof trigger === "string") {
    return messages.find((message) => message.role === "user" && message.id === trigger) ?? null;
  }
  return [...messages].reverse().find((message) => message.role === "user") ?? null;
}
